// dropdownの除外処理
(function () {
  // PC用セレクタ
  const pcSelectors = [
    'a.link-dropdown__link[href*="sort_by=title-ascending"]',
    'a.link-dropdown__link[href*="sort_by=title-descending"]',
    'a.link-dropdown__link[href*="sort_by=created-ascending"]'
  ];

  const pcTexts = [
    "アルファベット順, A-Z",
    "アルファベット順, Z-A",
    "古い商品順"
  ];

  // スマホ用テキスト一致による非表示対象
  const mobileTexts = [
    "アルファベット順, A-Z",
    "アルファベット順, Z-A",
    "古い商品順"
  ];

  function hideSortLinks() {
    // PCドロップダウン処理
    pcSelectors.forEach((selector, index) => {
      document.querySelectorAll(selector).forEach(el => {
        if (el.textContent.trim() === pcTexts[index]) {
          el.style.display = 'none';
        }
      });
    });

    // スマホ用フィルターリスト処理
    document.querySelectorAll('label.filter-group__item').forEach(label => {
      const span = label.querySelector('.filter-group__item__text');
      if (!span) return;

      const text = span.textContent.trim();
      if (mobileTexts.includes(text)) {
        label.style.display = 'none';
      }
    });
  }

  // 初回実行
  hideSortLinks();

  // DOM変化監視
const target = document.querySelector('.collection') || document.body;
if (target) {
  const observer = new MutationObserver(hideSortLinks);
  observer.observe(target, {
    childList: true,
    subtree: true
  });
}

  // URL変化監視
  let lastUrl = location.href;
  setInterval(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      setTimeout(hideSortLinks, 300);
    }
  }, 300);
})();




